// @core/api/endpoints/calendar/update_calendar_event_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarEventTypeDefinitionResponse,
  UpdateCalendarEventTypeRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Update calendar event type
 * Updates a calendar event type definition (default duration, booking config, lifecycle flags).
 */
export async function UpdateCalendarEventType(
  type_id: string,
  data: UpdateCalendarEventTypeRequest,
  options?: RequestOptions
): Promise<CalendarEventTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar-event-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.put<CalendarEventTypeDefinitionResponse>(requestPath, data, requestOptions);
}
